import { takeLatest, call } from 'redux-saga/effects'

import { FETCH_ANSWERS, DELETE_ANSWER } from 'Actions/answers'
import { fetchAnswers, deleteAnswer } from './helpers/answers'

export default function* appSaga() {
  yield takeLatest(FETCH_ANSWERS, fetchAnswers)
  yield takeLatest(DELETE_ANSWER, onDeleteAnswer)
}

const onDeleteAnswer = function* (action) {
  const { answerId } = action.payload
  yield call(deleteAnswer, answerId)
}
